// How a changed value reads in Activities history.
//
// The API records changes as stored, so dates arrive as ISO strings —
// "2026-08-20T14:00:00.000+07:00" — which is accurate and unreadable. Shown
// instead as "20-Aug-2026 14:00", the date format used across the portal.
//
// The wall-clock time written in the string is kept as is: it already carries
// its offset (the server's zone), and re-parsing it through the browser's
// timezone is exactly what shifts dates by a day. Only a UTC ("Z") value is
// converted, to the viewer's local time.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
const DATE_TIME = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?(Z|[+-]\d{2}:?\d{2})?$/;

const pad = (n) => String(n).padStart(2, '0');
const dateLabel = (y, m, d) => `${pad(d)}-${MONTHS[Number(m) - 1]}-${y}`;

export const formatAuditValue = (value) => {
  if (typeof value !== 'string') return String(value ?? '');
  const text = value.trim();

  const dateOnly = text.match(DATE_ONLY);
  if (dateOnly) return dateLabel(dateOnly[1], dateOnly[2], dateOnly[3]);

  const dateTime = text.match(DATE_TIME);
  if (!dateTime) return value;

  const [, y, m, d, hh, mm, zone] = dateTime;
  if (zone === 'Z') {
    const local = new Date(text);
    if (!Number.isNaN(local.getTime())) {
      return `${dateLabel(local.getFullYear(), local.getMonth() + 1, local.getDate())} ${pad(local.getHours())}:${pad(local.getMinutes())}`;
    }
  }
  return `${dateLabel(y, m, d)} ${hh}:${mm}`;
};

export default formatAuditValue;
